class Dashboard extends BaseClass {
  constructor(app) {
    super(app);
    this.isRendering = true;
    this.app = app;
    this.observerManager = new ImageObserverManager(this.app, null, null);
  }

  static filterCallback(response) {
    const app = PreBuilt;
    const status = response.status;
    let range = response.range;
    range = range.split(' - ');
    range = range.map(date => date.trim());
    let posts = _.values(window.calendarPosts);

    if (!app.isEmpty(range)) {
      posts = Utils.filterByDateRange(posts, range[0], range[1]);
    }

    if (!app.isEmpty(status)) {
      posts = posts.filter(obj => {
        return status.includes(obj.actionStatus);
      });
    }

    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    app.filterModal.modal('hide');
    aimi_calendar.refresh(app.calendarId, posts).then(function (response) {

    })

    if (app.isEmpty(posts)) {
      const noRecordsOptions = {
        title: 'No records found ',
        description: `I could not find any results for the filter you applied. Remove the filter or try different settings.`,
        addButton: {
          text: 'Clear Filter',
          onClick: () => {
            NoRecordsPlaceholder.destroy();
            aimi_calendar.refresh(app.calendarId, null).then(function (response) {

            })
          }
        },
        help: {
          text: 'Need Help ?',
          onClick: () => {
            console.log('Help clicked');
          }
        },
      };

      app.placeholder = new NoRecordsPlaceholder(app, $('.tab-content-calendar'), noRecordsOptions);
      app.placeholder.render({'class': 'no-records-placeholder m-3'});
    } else {
      let message = [];
      const messageStatic = `Showing results for filters with `;

      if (!app.isEmpty(range)) {
        message.push(`<span class="fw-semibold"> date range ${range[0]} to ${range[1]} </span>`);
      }

      message = messageStatic + message.join(' and ');
      app.Toast = new Toast(app, $('.tab-content-calendar'), {
        'message': message, closeButton: {
          text: 'Clear Filter',
          onClick: () => {
            Toast.destroy();
            aimi_calendar.refresh(app.calendarId, null).then(function (response) {

            })
          }
        }
      });
      app.Toast.render();
    }
  }

  async filter() {
    const app = this.app;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-dashboard-filter',
      template: 'dashboard__filter',
      title: 'Filter Data',
      saveButtonText: 'Filter',
      footerText: '',
      saveApi: '',
      saveApiCallBack: 'Dashboard.filterCallback',
    };

    this.app.inputPrompt(options).then(async function ($modal) {
      app.filterModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      progress.remove();

      const $input = $modal.find('input[name=range]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin"
        ],
        LockPlugin: {
          minDays: 2,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

    });
  }
}

(function (aimi_dashboard, $, app, undefined) {

  class LiveChart {
    constructor(chartElementId, autoRefreshCheckboxId) {
      this.chartEl = document.getElementById(chartElementId);
      this.autoRefreshCheckbox = document.getElementById(autoRefreshCheckboxId);
      this.chart = echarts.init(this.chartEl);
      this.time = [];
      this.counts = [];
      this.maxPoints = 30; // Limit to 30 days
      this.isFetching = false;
      this.autoRefresh = false;
      this.intervalId = null;
      this.progressInterval = null;
      this.isDayView = false; // Flag for day view

      this.initChart();
      this.attachEventListeners();
      this.toggleAutoRefresh();
    }

    showProgressBar() {
      let barContainer = document.querySelector('.progress');
      let bar = barContainer.querySelector('.progress-bar');

      bar.style.width = "5%";

      this.progressInterval = setInterval(() => {
        let currentWidth = parseFloat(bar.style.width);
        if (currentWidth < 90) {
          bar.style.width = (currentWidth + Math.random() * 15) + "%";
        }
      }, 100);
    }

    hideProgressBar() {
      let barContainer = document.querySelector('.progress');
      let bar = barContainer.querySelector('.progress-bar');
      clearInterval(this.progressInterval);
      bar.style.width = "100%";
      setTimeout(() => {
        bar.style.width = "0%";
      }, 300);
    }

    toggleAutoRefresh() {
      this.autoRefresh = this.autoRefreshCheckbox.checked;
      if (this.autoRefresh) {
        this.fetchData(true);
        this.intervalId = setInterval(() => this.fetchData(true), 5000);
      } else {
        clearInterval(this.intervalId);
      }
    }

    toggleDayView() {
      this.isDayView = !this.isDayView;
      if (this.isDayView) {
        this.renderChartByDay();
      } else {
        this.fetchData(true);
      }
    }

    async fetchData(live = true) {
      if (!this.autoRefresh && live) return;
      if (this.isFetching) return;
      this.isFetching = true;
      this.showProgressBar();

      try {
        let api = live ? '/api/geo/live-visitors' : '/api/geo/visitors';
        let response = await app.apis['dashboard'].fetchByUrl(api);
        let result = response;
        this.chartEl.classList.remove('m-progress');

        if (result.length > 0) {
          result.sort((a, b) => new Date(a.min_log_time) - new Date(b.min_log_time)); // Sort by date

          if (live) {
            let lastEntry = result[result.length - 1];
            this.updateChartData(lastEntry);
          } else {
            this.time.length = 0;
            this.counts.length = 0;
            result.forEach(entry => this.updateChartData(entry));
          }
        } else {
          this.updateChartData([]);
        }

        this.chart.setOption({
          xAxis: {data: this.time},
          series: [{data: this.counts}]
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isFetching = false;
        this.hideProgressBar();
      }
    }

    renderChartByDay() {
      // Clear previous data and set up new arrays for day view
      this.time = [];
      this.counts = [];
      this.fetchData(false); // Fetch historical data (not live)

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let dataIndex = params[0].dataIndex;
            return `Date: ${this.time[dataIndex]}<br>Visitors: ${this.counts[dataIndex].value}`;
          }
        },
        xAxis: {data: this.time},  // Set x-axis to display date
        series: [{data: this.counts}]  // Update data for the chart
      });
    }

    updateChartData(entry) {
      // Assuming entry contains date and visitor data
      let date = new Date(entry.date); // Get date for the chart

      let visitorCount = entry.visitor_count || 0;
      let ipList = entry.ip_addresses ? entry.ip_addresses.replace(/, /g, '<br>') : '-';

      entry.min_log_time = new Date(entry.min_log_time);
      entry.max_log_time = new Date(entry.max_log_time);

      let minLogTimeLocal = new Date(entry.min_log_time.getTime() - entry.min_log_time.getTimezoneOffset() * 60000).toLocaleTimeString();
      let maxLogTimeLocal = new Date(entry.max_log_time.getTime() - entry.max_log_time.getTimezoneOffset() * 60000).toLocaleTimeString();

      let logTimes = `${minLogTimeLocal} - ${maxLogTimeLocal}`;

      // Format date to a string for the x-axis
      let dateStr = date.toLocaleDateString();

      this.time.push(dateStr);
      this.counts.push({value: visitorCount, name: ipList, logTimes});

      // Keep the data size limited to the max points (30 days)
      if (this.time.length > this.maxPoints) {
        this.time.shift();
        this.counts.shift();
      }
    }

    initChart() {
      let option = {
        grid: {left: 40, right: 10, top: 10, bottom: 40, containLabel: true},
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let dataIndex = params[0].dataIndex;
            // Hide IP addresses in day view
            if (this.isDayView) {
              return `Date: ${this.time[dataIndex]}<br>Visitors: ${this.counts[dataIndex].value}`;
            }
            // Show IP addresses for live view
            return `Date: ${this.counts[dataIndex].logTimes}<br>Visitors: ${this.counts[dataIndex].value}<br>IP: ${this.counts[dataIndex].name}`;
          }
        },
        xAxis: {type: 'category', name: 'Date', data: this.time},
        yAxis: {
          type: 'value',
          name: 'Visitor Count',
          min: 0,
          minInterval: 1
        },
        series: [{name: 'Visitors', type: 'line', data: this.counts, smooth: true}]
      };
      this.chart.setOption(option);
    }

    attachEventListeners() {
      this.autoRefreshCheckbox.addEventListener('change', () => this.toggleAutoRefresh());
      // Attach event listener to toggle between day view and live view
      //document.getElementById('toggleDayView').addEventListener('click', () => this.toggleDayView());
    }
  }


  function scrollList(activityList) {
    // Stop any ongoing animation first
    activityList.stop(true, true);

    let listHeight = activityList.height() / 2; // Original list height before cloning

    activityList.animate(
        { top: `-${listHeight}px` },
        500000, // 150 seconds (2 minutes) for slower scroll
        'linear',
        function () {
          // Reset position instantly
          activityList.css('top', '0px');
          scrollList(activityList); // Restart animation
        }
    );
  }


  function setActivityContainerHeight() {
    const activityList = $('.activity-list-wrapper');
    const activityContainer = $('.activity-container');
    const parentHeight = activityContainer.closest('.card-body').height();
    activityContainer.height(parentHeight - 50);

    if(!app.isEmpty( window.leadActivityList)) {
      window.leadActivityList.onRenderList().then(function (response) {
        let listItems = activityList.children();

        // Clone the list items for a seamless effect
        activityList.append(listItems.clone());

        scrollList(activityList); // Start scrolling
      })
    }
  }

  async function loadActivities() {

    const activityRow = 'dashboard__activity-row';

    const container = $('[data-recent-acitivities]');

    setActivityContainerHeight();

    window.leadActivityList = new LeadActivity(app, container, null, activityRow ,'timestamp', 'DESC', 50);
    window.leadActivityList.renderList();
    setActivityContainerHeight();
  }


  async function loadPostStats() {
    let response = await app.apis['dashboard'].socialStats();
    const data = response.data;

    const $postsPublishedContainer = $('[data-posts-published]');
    const $socialImpressionsContainer = $('[data-social-impressions]');
    const $socialEngagementsContainer = $('[data-social-engagements]');

    const postsPublishedStats = new PostsPublished(app, $postsPublishedContainer, data, 'dashboard__posts-published' );
    postsPublishedStats.render();

    const socialImpressionStats = new SocialImpressions(app, $socialImpressionsContainer, data, 'dashboard__social-impressions' );
    socialImpressionStats.render();

    const socialEngagementStats = new SocialEngagements(app, $socialEngagementsContainer,  data, 'dashboard__social-engagements' );
    socialEngagementStats.render();
  }

  async function loadDashboardData() {

    const $leadsAddedContainer = $('[data-leads-added]');
    const $emailsSentContainer = $('[data-emails-sent]');
    const $emailsEngagementContainer = $('[data-emails-engagement]');

    const leadStats = new LeadStats(app, $leadsAddedContainer, 'dashboard__leads-added' );
    leadStats.render();

    leadStats.onRenderList().then(function () {
      setActivityContainerHeight();

      const emailsSentStats = new EmailsSentStats(app, $emailsSentContainer, 'dashboard__emails-sent' );
      emailsSentStats.render();

      loadPostStats().then(function () {
        loadActivities();
        setActivityContainerHeight();
      });

      // Instantiate the class
      const liveChart = new LiveChart('geoChartData', 'autoRefreshLivePixels');
      liveChart.toggleDayView();

      emailsSentStats.onRenderList().then(function () {

        const emailsEngagementStats = new EmailsEngagementStats(app, $emailsEngagementContainer, 'dashboard__emails-engagement' );
        emailsEngagementStats.render();

      })
    });

  }

  function loadGeoTableData() {

    const geoRow = 'dashboard__geo-row';

    const container = $('[data-geo-table]');

    const geoStatsList = new GeoStatsList(app, container, geoRow );

    geoStatsList.onRenderList().then(function (response) {

    })

  }

  aimi_dashboard.init = function () {
    loadDashboardData();

    // Event for instance switch
    $(document).off('submit.mdcdot_instance_user').on('submit.mdcdot_instance_user', 'form[name=mdcdot_instance_user]', function (e) {
      const $form = $(this);
    })

    $(document).off('change.mdcdot_instance_user').on('change.mdcdot_instance_user', 'form[name=mdcdot_instance_user] select', function (e) {
      const $form = $('form[name=mdcdot_instance_user]');
      $form.submit();
      return e.preventDefault();
    })

    $(document).off('change.mdcdot_dashboard_pixels_view').on('change.mdcdot_dashboard_pixels_view', ':input[name=livePixelsView]', function (e) {
      const $this = $(this);
      const view = $this.val();
      const geoChartData = $('#geoChartData');
      const geoTableData = $('#geoTableData');

      if(view === 'table') {
        geoChartData.addClass('d-none');
        geoTableData.removeClass('d-none');
        loadGeoTableData();
      }

      if(view === 'graph') {
        geoTableData.addClass('d-none');
        geoChartData.removeClass('d-none');
      }

      return e.preventDefault();
    })

    $(document).off('click.mdcdot_dashboard_events').on('click.mdcdot_dashboard_events', '[data-dashboard-action]', async function (e) {
      const $this = $(this); // Cache the clicked element
      const action = $this.data('dashboard-action'); // Extract the action from the data attribute


      switch (action) {
        case 'pixels-tracking':
          const trackingCodeRaw = `
<script type="text/javascript">
  __dot_site_id = '${window.mdcdotInstance}';
  __dot_user = '1';
  __dot_site =  '${window.mdcdotInstance}';
  (function(d, t) {
    var g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
    g.src = '//track.mdcdot.com/js/dist/track/_.min.js';
    s.parentNode.insertBefore(g, s);
  }(document, 'script'));
</script>
`;
          const trackingCodeDisplay = `
  <pre style="background:#f5f5f5;padding:10px;border-radius:5px;">
&lt;script type="text/javascript"&gt;
  __dot_site_id = '${window.mdcdotInstance}';
  __dot_user = '1';
  __dot_site = '${window.mdcdotInstance}';
  (function(d, t) {
    var g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
    g.src = '//track.mdcdot.com/js/dist/track/_.min.js';
    s.parentNode.insertBefore(g, s);
  }(document, 'script'));
&lt;/script&gt;
  </pre>
`;

          app.confirm('Pixels Tracking', trackingCodeDisplay, {'confirmButtonText' : 'Copy'}).then(function (response) {
            const $button = response.button;
            const confirm = response.confirm;
            const $modal = response.modal;

            // Create clipboard instance only after modal is shown
            const clipboard = new ClipboardJS($button[0]); // Bind directly to this confirm button

            $button.val(trackingCodeRaw);
            $button.attr('data-clipboard-text', trackingCodeRaw);

            clipboard.on('success', function (ce) {
              app.notify('success', "Copied To Device");
              ce.clearSelection();
              app.hideModal($modal);
            });

            // If the user confirms the deletion, proceed with the delete operation.
            if (confirm === true) {
              $button.click();
            }
          })
          break;

        case 'filter' :
          const newDashboard = new Dashboard(app);
          newDashboard.filter();
          break;
      }
    })

    app.initSimpleBar(document.getElementById('tab_block_1'));

    this.downnloadPdf();
  }

  aimi_dashboard.downnloadPdf = function () {

    const getPdfName = function () {
      const instance = $('#instance').val();
      const userId = $('#user').val();

      return `${userId}-${instance}`;
    }

    document.getElementById("download").addEventListener("click", function () {
      const tabSection = document.querySelector('#tab_block_1');
      $(tabSection).addClass('pdf-preview');

      // Set PDF options
      let opt = {
        margin: 0.5,
        filename: getPdfName(),
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 2},
        jsPDF: {unit: 'in', format: [20, 30], orientation: 'portrait'}
      };

      setTimeout(function () {
        html2pdf().from(tabSection).set(opt).save().then(function () {
          $(tabSection).removeClass('pdf-preview');
        })
      }, 300);

    });

  }

}(window.aimi_dashboard = window.aimi_dashboard || {}, jQuery, PreBuilt));